<template>
  <div class="col-md-6">
    <form-group-input
      ref="input"
      type="email"
      :label="label"
      :disabled="conjugeDisabled"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: (required && !conjugeDisabled), email: true }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-email-conjuge",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  computed: {
    crm() {
      return this.$store.state.crm;
    }
  },
  asyncComputed: {
    conjugeDisabled() {
      let enabled = this.crm.conjuge;

      return !enabled;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/EmailConjuge.vue